/**
 * Mixpanel Event Tracking Initializer
 */
(function (f, b) {
  if (!b.__SV) {
    var e, g, i, h;
    window.mixpanel = b;
    b._i = [];
    b.init = function (e, f, c) {
      function g(a, d) {
        var b = d.split(".");
        2 == b.length && ((a = a[b[0]]), (d = b[1]));
        a[d] = function () {
          a.push([d].concat(Array.prototype.slice.call(arguments, 0)));
        };
      }
      var a = b;
      "undefined" !== typeof c ? (a = b[c] = []) : (c = "mixpanel");
      a.people = a.people || [];
      a.toString = function (a) {
        var d = "mixpanel";
        "mixpanel" !== c && (d += "." + c);
        a || (d += " (stub)");
        return d;
      };
      a.people.toString = function () {
        return a.toString(1) + ".people (stub)";
      };
      i =
        "disable time_event track track_pageview track_links track_forms track_with_groups add_group set_group remove_group register register_once alias unregister identify name_tag set_config reset opt_in_tracking opt_out_tracking has_opted_in_tracking has_opted_out_tracking clear_opt_in_out_tracking start_batch_senders people.set people.set_once people.unset people.increment people.append people.union people.track_charge people.clear_charges people.delete_user people.remove".split(
          " "
        );
      for (h = 0; h < i.length; h++) g(a, i[h]);
      var j = "set set_once union unset remove delete".split(" ");
      a.get_group = function () {
        function b(c) {
          d[c] = function () {
            call2_args = arguments;
            call2 = [c].concat(Array.prototype.slice.call(call2_args, 0));
            a.push([e, call2]);
          };
        }
        for (
          var d = {},
          e = ["get_group"].concat(Array.prototype.slice.call(arguments, 0)),
          c = 0;
          c < j.length;
          c++
        )
          b(j[c]);
        return d;
      };
      b._i.push([e, f, c]);
    };
    b.__SV = 1.2;
    e = f.createElement("script");
    e.type = "text/javascript";
    e.async = !0;
    e.src =
      "undefined" !== typeof MIXPANEL_CUSTOM_LIB_URL
        ? MIXPANEL_CUSTOM_LIB_URL
        : "file:" === f.location.protocol &&
          "//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js".match(/^\/\//)
          ? "https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js"
          : "//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js";
    g = f.getElementsByTagName("script")[0];
    g.parentNode.insertBefore(e, g);
  }
})(document, window.mixpanel || []);

mixpanel.init("aa4ea9db82722024e02782fb6aecf509", {
  debug: false, // this flag is to see the mixpanel events in the console of the browser
  track_pageview: false, // this flag is to trigger default '$mb_page_view' event each time a new page is viewed
  persistence: "localStorage",
});

const mixpanel_distinct_id = localStorage.getItem("mixpanel_distinct_id");
// console.log("mixpanel_distinct_id", mixpanel_distinct_id);
if (mixpanel_distinct_id) {
  mixpanel.identify(mixpanel_distinct_id);
}
mixpanel.people.set_once({
  last_updated: new Date(),
});

//////////////// Here Starts The Mixpanel Event Trackin Code ///////////////////

/**
 * Function to get the Maping of Native code data from the 'vego-event-attr-' pre added attributes,
 * which will be used to map the native code data to the response needed to send to the event
 */
function getNativeCodeDataForEventFromElement(element) {

  const regex = /vego-event-attr-(.*)/;
  const attributes = element.attributes; // Get all the attributes of the element
  const customAttributes = {}; // Create an object to store the attributes

  // Loop through all the attributes
  for (let i = 0; i < attributes.length; i++) {
    const attr = attributes[i];
    const match = attr.name.match(regex);

    // console.log("match for attr: ", match, attr);


    // Check if the attribute starts with "cust-attr"
    if (match) {

      // Split the attribute name to get the key and value
      const [key, value] = [match[1], attr.value]; // value after the match of regex, in this case the "Actual Key Name To Put In Properties" of the from the attr key

      // Store the key-value pair in the customAttributes object
      customAttributes[key] = value;

    }

    // console.log("customAttributes: ", customAttributes);
  }

  // Return the customAttributes object
  return customAttributes;
}

/**
 * this is the mapping that is used to get the custom function in case of the "customFunction" enabled event
 */
const eventsToCustomFunctionMap = {
  "add-to-cart-clicked": getProductDetails,
  // "add-to-cart-from-drawer-clicked": getProductDetails,
  "remove-from-cart-clicked": getProductDetails,
  // "remove-from-cart-from-drawer-clicked": getProductDetails,
  "product-clicked": getProductDetails,
  // "product-clicked-from-reviews": getProductDetails,
  // "product-clicked-from-image": getProductDetails,
  // "product-clicked-from-title": getProductDetails,
  "add-to-cart-frequently-paired-with-clicked": getProductDetails,
  "add-to-cart-the-perfect-pair-clicked": getProductDetails,
};

/****************************************************************************************************/
/**
 * All custom functions definitions should go here
 */
function getProductDetails(
  config,
  element = null,
) {
  let apiResData = {};
  let nativeCodeDataForEventFromElement = {};
  const elementDataMap = config.elementDataMap || {};
  const constDataMap = config.constDataMap || {};
  const needsNativeCodeData = config.needsNativeCodeData;

  const latestProductDetailsForParameters = {};

  if (elementDataMap && Object.keys(elementDataMap).length > 0) {
    for (const [mpProp, elementProp] of Object.entries(elementDataMap)) {
      latestProductDetailsForParameters[mpProp] =
        element.getAttribute(elementProp);
    }
  }

  if (constDataMap && Object.keys(constDataMap).length > 0) {
    for (const [mpProp, constProp] of Object.entries(constDataMap)) {
      latestProductDetailsForParameters[mpProp] = constProp;
    }
  }

  if (needsNativeCodeData) {
    nativeCodeDataForEventFromElement = getNativeCodeDataForEventFromElement(element);

    for (const [mpProp, nativeProp] of Object.entries(
      nativeCodeDataForEventFromElement
    )) {
      latestProductDetailsForParameters[mpProp] = nativeProp;
    }
  }

  if (config.needsAPIData) {

    let fetchUrl = config.apiUrl
      ? config.apiUrl
      : "" || latestProductDetailsForParameters?.['api-url-for-data']
        ? "https://vegogarden.com" +
        latestProductDetailsForParameters?.['api-url-for-data']
        : "" || latestProductDetailsForParameters.productHandle
          ? "https://vegogarden.com/products/" +
          latestProductDetailsForParameters.productHandle
          : "";

    if (fetchUrl) {
      const dotSplittedUrlParts = fetchUrl?.split('.');

      if (dotSplittedUrlParts && dotSplittedUrlParts.length > 1 && dotSplittedUrlParts[dotSplittedUrlParts.length - 1] != 'js') {
        fetchUrl = fetchUrl + '.js';
      }

    }

    $.ajax({
      url: `${fetchUrl}`,
      type: "GET",
      dataType: "json",
      async: true, // This makes the AJAX call asynchronous
      success: function (data) {
        // console.log("data from ajax query: ", data);

        var latestAddedProductItem = data;

        for (const [mpProp, apiProp] of Object.entries(config.apiDataMap)) {
          latestProductDetailsForParameters[mpProp] = latestAddedProductItem?.[apiProp];

          if (["price", "sku"].includes(apiProp)) {
            latestProductDetailsForParameters[mpProp] =
              latestAddedProductItem?.variants?.[0]?.[apiProp];
          }

          if (apiProp == "url") {
            latestProductDetailsForParameters[mpProp] =
              nativeCodeDataForEventFromElement["api-url-for-data"];
          }
        }

        trackMixpanelEvent(config.eventName, latestProductDetailsForParameters);

        return;

      },
      error: function (error) {

        // console.log("Error fetching product data:", error);

        trackMixpanelEvent(config.eventName, latestProductDetailsForParameters);

        return;

      },
    });
  } else {

    trackMixpanelEvent(config.eventName, latestProductDetailsForParameters);

    return;

  }

  // We are doing async api calls so this line should not be executed else the tracking will be done before api call is finished
  // trackMixpanelEvent(config.eventName, latestProductDetailsForParameters);
  // return;
}
/****************************************************************************************************/

/**
 * Mapping for event configuration to get the config of events based on their key in O(1) ( in average case obviously, but that is good enough for us for now )
 */
var eventConfigMap = new Map();
for (const config of eventConfig) {
  eventConfigMap.set(config.key, config);
}

/**
 * Function to track events with Mixpanel
 */
function trackMixpanelEvent(eventName, properties = {}) {
  if (window.mixpanel) {
    window.mixpanel.track(eventName, properties);
  } else {
    console.error("Mixpanel is not initialized.");
  }
}

/**
 * Function to fetch data from API and send event to mixpanel
 */
async function getEventsParameterAndTriggerEvent(element = null, config) {
  try {
    let eventProperties = {};
    let apiResData = {};
    let nativeCodeDataForEventFromElement = {};

    if (config.customFunction) {
      eventProperties = eventsToCustomFunctionMap[config.key](
        config,
        element
      );

    } else {

      if (config.needsElementData) {
        for (const [mpProp, elementProp] of Object.entries(
          config.elementDataMap
        )) {
          eventProperties[mpProp] = element.getAttribute(elementProp);
        }
      }

      if (config.needsConstData) {
        for (const [mpProp, constProp] of Object.entries(config.constDataMap)) {
          eventProperties[mpProp] = constProp;
        }
      }

      if (config.needsNativeCodeData) {
        nativeCodeDataForEventFromElement = getNativeCodeDataForEventFromElement(element);

        for (const [mpProp, nativeProp] of Object.entries(
          nativeCodeDataForEventFromElement
        )) {
          eventProperties[mpProp] = nativeProp;
        }
      }

      if (config.needsAPIData) {

        let fetchUrl = config.apiUrl
          ? config.apiUrl
          : "" || latestProductDetailsForParameters?.['api-url-for-data']
            ? "https://vegogarden.com" +
            latestProductDetailsForParameters?.['api-url-for-data']
            : "" || latestProductDetailsForParameters.productHandle
              ? "https://vegogarden.com/products/" +
              latestProductDetailsForParameters.productHandle
              : ""

        if (fetchUrl) {
          const dotSplittedUrlParts = fetchUrl?.split('.');

          if (dotSplittedUrlParts && dotSplittedUrlParts.length > 1 && dotSplittedUrlParts[dotSplittedUrlParts.length - 1] != 'js') {
            fetchUrl = fetchUrl + '.js';
          }

        }

        $.ajax({
          url: `${fetchUrl}`,
          type: "GET",
          dataType: "json",
          async: true, // This makes the AJAX call asynchronous
          success: function (data) {
            // console.log("data from ajax query: ", data);

            for (const [mpProp, apiProp] of Object.entries(config.apiDataMap)) {
              eventProperties[mpProp] = data?.[apiProp];
            }

            trackMixpanelEvent(config.eventName, eventProperties);

            return;
          },
          error: function (error) {
            // console.log("Error fetching product data:", error);

            trackMixpanelEvent(config.eventName, eventProperties);

            return;
          },
        });
      } else {

        trackMixpanelEvent(config.eventName, eventProperties);

        return;
      }
    }

    // We are doing async api calls so this line should not be executed else the tracking will be done before api call is finished
    // trackMixpanelEvent(config.eventName, eventProperties);
    // return;
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}

/**
 * element and event listner against it, this map is used to manage all the event listeners that we have attached within our system
 */
const eventListenersMap = new Map();

function eventListenerForElement(eventConfigForElement, element) {
  if (eventConfigForElement?.eventHasParameters) {
    getEventsParameterAndTriggerEvent(element, eventConfigForElement);
  } else {
    trackMixpanelEvent(eventConfigForElement?.eventName);
  }
}

function addEventListenerToElementAndManageItsMap(element, newListener) {
  // Check if there's already a listener registered
  const existingListener = eventListenersMap.has(element)
    ? eventListenersMap.get(element)
    : null;

  if (!existingListener) {
    // Add the new listener
    element.addEventListener("click", newListener);
    // console.log('Added new listener for element', element);

    // Update the map with the new listener
    eventListenersMap.set(element, newListener);
  }
}

/**
 * Attaching event listeners based on configuration
 */
function setupEventListeners() {
  // Here we are splitting the event key from data-vego-event from the parameters we need from the shopify liquid code.
  const elementArray = Array.from(
    document.querySelectorAll("[data-vego-event]")
  );

  elementArray.forEach((element) => {
    setupEventListenerForElement(element);
  });
}

/**
 * Attach event listner to a single element
 */
function setupEventListenerForElement(element) {
  const dataVegoEventKey = element.getAttribute("data-vego-event")

  let eventConfigForElement = eventConfigMap.get(dataVegoEventKey);

  addEventListenerToElementAndManageItsMap(element, () => {
    eventListenerForElement(eventConfigForElement, element);
  });
}

/**
 * This is the list of observers that has all the observers for the dynamic parent componenents that we need to handle.
 *
 * NEED: this is needed for cleaning all the previous observers at each "DOMContentLoaded" and attach new one only for those dynamic parent elements that are currently present in the DOM.
 */

let observers = [];

/**
 * Configuration for dynamic components to handle interaction with them ( this is for the componenets that lazily loads or is not loaded at the time of page load or on scroll etc. )
 */

function handleDynamicComponenetInteraction(parentElementQuery) {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === "childList") {
        mutation.addedNodes.forEach((node) => {
          // console.log("child nodes: ", node.childNodes)
          if (node.nodeType === 1 && !eventListenersMap.has(node)) {
            // console.log('New node added, setting up events:', node);
            elementsWithVegoEventAttribute =
              node.querySelectorAll("[data-vego-event]");

            elementsWithVegoEventAttribute.forEach((el) => {
              // console.log('element for event:', el);
              setupEventListenerForElement(el);
            });
          }
        });
      }
    });
  });

  /**
   * Start observing the parent component by configuration using mutaion observer
   */
  const parentComponent = document.querySelector(parentElementQuery);

  if (parentComponent) {
    observer.observe(parentComponent, {
      childList: true, // observe direct children
      subtree: true, // and lower descendants too
    });

    observers.push(observer);
  }
}

const defaultPageToPageEvent = {
  'index': "Homepage Viewed",
  'product': "Product Viewed",
  'collection': "Collection Viewed",
}

  function isBot() {
    if (navigator.webdriver) return true;
    if (window.document.__selenium_unwrapped || 
        window.callPhantom || 
        window._phantom) {
      return true;
    }
    return false;
  }

/**
 * Attaching event listener on "DOMContentLoaded" event to trigger our application logic on that event
 */
document.addEventListener("DOMContentLoaded", function () {

  if (isBot()) {
    return;
  }

  setupEventListeners();
  /**
   * Clean up previous observers
   */
  observers.forEach((observer) => observer.disconnect());
  observers = []; // Clear the array to start fresh

  /**
   * Function to handle the intersection changes
   */
  observationConfig.forEach((config) => {
    handleDynamicComponenetInteraction(config.parentElementQuery);
  });

  /**
    * Fire event of home page viewed, if the current page is 'index' page
    */

  if (source && source == 'collection' || source == 'product' || source == 'index') {
    const properties = {};

    // const urlComponenetsForPage = window.page_type.split('/');

    const urlComponenetsForPage = window.location.href.split('/');

    properties['page_name'] = urlComponenetsForPage[urlComponenetsForPage.length - 1];
    properties['page_url'] = window.location.href;
    properties['page_type'] = source;

    // conditionaly maintaining index, product and collection pages visiting event
    if(source == 'index'){
      trackMixpanelEvent(defaultPageToPageEvent[source], properties);
      return;
    }

    if (source == 'product') {

      properties['productUrl'] = window.location.href;

      let fetchUrl = properties['productUrl'];

      if (fetchUrl) {
        const dotSplittedUrlParts = fetchUrl?.split('.');

        if (dotSplittedUrlParts && dotSplittedUrlParts.length > 1 && dotSplittedUrlParts[dotSplittedUrlParts.length - 1] != 'js') {
          fetchUrl = fetchUrl + '.js';
        }

      }

      $.ajax({
        url: `${fetchUrl}`,
        type: "GET",
        dataType: "json",
        async: true, // This makes the AJAX call asynchronous
        success: function (data) {
          // console.log("data from ajax query: ", data);

          var latestAddedProductItem = data;

          properties['source'] = source;
          properties['productTitle'] = latestAddedProductItem?.title;
          properties['productName'] = latestAddedProductItem?.handle;
          properties['productPrice'] = latestAddedProductItem?.variants?.[0]?.price;
          properties['category'] = latestAddedProductItem?.product_type;
          properties['varientSku'] = latestAddedProductItem?.variants?.[0]?.sku;

          trackMixpanelEvent(defaultPageToPageEvent[source], properties);

          return;

        },
        error: function (error) {

          // console.log("Error fetching product data:", error);

          trackMixpanelEvent(defaultPageToPageEvent[source], latestProductDetailsForParameters);

          return;

        },
      });
    }

    if (source == 'collection') {

      properties['source'] = source;
      properties['collectionUrl'] = window.location.href;

      trackMixpanelEvent(defaultPageToPageEvent[source], properties);

      return;

    }

    // if (source !== 'index' && source !== 'product' && source !== 'collection') {
      
    //   trackMixpanelEvent('Other Pages Viewed', properties);

    //   return;
    // }
  }
});
